import "bootstrap";
import { Modal } from "bootstrap";

const ua = navigator.userAgent ?? "";
const isIos = /iPhone|iPad|iPod/i.test(ua);
const isAndroid = /Android/i.test(ua);
const isDesktop = !isIos && !isAndroid;

const modalEl = document.getElementById("appPlatformModal");
const bsModal = modalEl ? new Modal(modalEl) : null;
const subtitle = document.getElementById("appPlatformModalSubtitle");
const iosBtn = document.getElementById("appPlatformIosBtn") as HTMLAnchorElement | null;
const androidBtn = document.getElementById("appPlatformAndroidBtn") as HTMLAnchorElement | null;

document.querySelectorAll<HTMLButtonElement>(".app-open-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
        const storeUrl = btn.dataset.storeUrl ?? "";
        const androidDeepLink = btn.dataset.androidDeepLink ?? "";
        const iosUrl = btn.dataset.iosUrl ?? "";
        const iosDeepLink = btn.dataset.iosDeepLink ?? "";
        const platforms = (btn.dataset.platforms ?? "").split(",");
        const hasIos = platforms.includes("ios") && iosUrl !== "";
        const hasAndroid = platforms.includes("android");

        if (isIos && hasIos) {
            window.location.href = iosDeepLink || iosUrl;
            return;
        }
        if (isAndroid && hasAndroid) {
            window.location.href = androidDeepLink || storeUrl;
            return;
        }
        if (isDesktop && !hasIos && hasAndroid) {
            window.open(storeUrl, "_blank", "noreferrer");
            return;
        }

        if (bsModal && subtitle && iosBtn && androidBtn) {
            const card = btn.closest(".app-card");
            const nameEl = card?.querySelector(".app-name");
            const appName = nameEl?.textContent?.trim() ?? "";
            subtitle.textContent = `Sélectionnez le store pour télécharger ${appName}.`;

            androidBtn.href = hasAndroid ? storeUrl : "#";
            androidBtn.style.display = hasAndroid ? "" : "none";

            iosBtn.href = hasIos ? iosUrl : "#";
            iosBtn.style.display = hasIos ? "" : "none";

            bsModal.show();
        }
    });
});
